export interface IOrganPickupDelivery {
    id: number,
    centerAlias: string,
    centerName: string,
    nkrLiason: string,
    earlyPU: number,
    latestDT: string,
    centerTimeZone: string,
    shipRange: string,
    pickupAddresses: string,
    pickupCity: string,
    pickupState: string,
    pickupPostalCode: string,
    deliveryAddresses: string,
    deliveryCity: string,
    deliveryState: string,
    deliveryPostalCode: string,
    notes: string,
    earlyPickupUtc: string,
    latestDeliveryUtc: string
}


